import i18n from "i18next";
import { Country } from "src/api/generated/io/aavo/applications/db/erp/types/country.ts";

export type CountryTranslationKey = `country_${Lowercase<Country>}`;

export interface CountryOption {
	code: Country;
	isoCode: string;
	labelKey: CountryTranslationKey;
}

export const DEFAULT_COUNTRY_CODE: Country = "FINLAND" as Country;

const COUNTRY_ISO_CODES: Record<string, string> = {
	AFGHANISTAN: "AF",
	ALBANIA: "AL",
	ALGERIA: "DZ",
	AMERICAN_SAMOA: "AS",
	ANDORRA: "AD",
	ANGOLA: "AO",
	ANGUILLA: "AI",
	ANTARCTICA: "AQ",
	ANTIGUA_AND_BARBUDA: "AG",
	ARGENTINA: "AR",
	ARMENIA: "AM",
	ARUBA: "AW",
	AUSTRALIA: "AU",
	AUSTRIA: "AT",
	AZERBAIJAN: "AZ",
	BAHAMAS: "BS",
	BAHRAIN: "BH",
	BANGLADESH: "BD",
	BARBADOS: "BB",
	BELARUS: "BY",
	BELGIUM: "BE",
	BELIZE: "BZ",
	BENIN: "BJ",
	BERMUDA: "BM",
	BHUTAN: "BT",
	BOLIVIA_PLURINATIONAL_STATE_OF: "BO",
	BONAIRE_SINT_EUSTATIUS_AND_SABA: "BQ",
	BOSNIA_AND_HERZEGOVINA: "BA",
	BOTSWANA: "BW",
	BOUVET_ISLAND: "BV",
	BRAZIL: "BR",
	BRITISH_INDIAN_OCEAN_TERRITORY: "IO",
	BRUNEI_DARUSSALAM: "BN",
	BULGARIA: "BG",
	BURKINA_FASO: "BF",
	BURUNDI: "BI",
	CABO_VERDE: "CV",
	CAMBODIA: "KH",
	CAMEROON: "CM",
	CANADA: "CA",
	CAYMAN_ISLANDS: "KY",
	CENTRAL_AFRICAN_REPUBLIC: "CF",
	CHAD: "TD",
	CHILE: "CL",
	CHINA: "CN",
	CHRISTMAS_ISLAND: "CX",
	COCOS_KEELING_ISLANDS: "CC",
	COLOMBIA: "CO",
	COMOROS: "KM",
	CONGO: "CG",
	CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: "CD",
	COOK_ISLANDS: "CK",
	COSTA_RICA: "CR",
	CROATIA: "HR",
	CUBA: "CU",
	CURACAO: "CW",
	CYPRUS: "CY",
	CZECHIA: "CZ",
	COTE_D_IVOIRE: "CI",
	DENMARK: "DK",
	DJIBOUTI: "DJ",
	DOMINICA: "DM",
	DOMINICAN_REPUBLIC: "DO",
	ECUADOR: "EC",
	EGYPT: "EG",
	EL_SALVADOR: "SV",
	EQUATORIAL_GUINEA: "GQ",
	ERITREA: "ER",
	ESTONIA: "EE",
	ESWATINI: "SZ",
	ETHIOPIA: "ET",
	FALKLAND_ISLANDS_MALVINAS: "FK",
	FAROE_ISLANDS: "FO",
	FIJI: "FJ",
	FINLAND: "FI",
	FRANCE: "FR",
	FRENCH_GUIANA: "GF",
	FRENCH_POLYNESIA: "PF",
	FRENCH_SOUTHERN_TERRITORIES: "TF",
	GABON: "GA",
	GAMBIA: "GM",
	GEORGIA: "GE",
	GERMANY: "DE",
	GHANA: "GH",
	GIBRALTAR: "GI",
	GREECE: "GR",
	GREENLAND: "GL",
	GRENADA: "GD",
	GUADELOUPE: "GP",
	GUAM: "GU",
	GUATEMALA: "GT",
	GUERNSEY: "GG",
	GUINEA: "GN",
	GUINEA_BISSAU: "GW",
	GUYANA: "GY",
	HAITI: "HT",
	HEARD_ISLAND_AND_MCDONALD_ISLANDS: "HM",
	HOLY_SEE_VATICAN_CITY_STATE: "VA",
	HONDURAS: "HN",
	HONG_KONG: "HK",
	HUNGARY: "HU",
	ICELAND: "IS",
	INDIA: "IN",
	INDONESIA: "ID",
	IRAN_ISLAMIC_REPUBLIC_OF: "IR",
	IRAQ: "IQ",
	IRELAND: "IE",
	ISLE_OF_MAN: "IM",
	ISRAEL: "IL",
	ITALY: "IT",
	JAMAICA: "JM",
	JAPAN: "JP",
	JERSEY: "JE",
	JORDAN: "JO",
	KAZAKHSTAN: "KZ",
	KENYA: "KE",
	KIRIBATI: "KI",
	KOREA_DEMOCRATIC_PEOPLE_S_REPUBLIC_OF: "KP",
	KOREA_REPUBLIC_OF: "KR",
	KUWAIT: "KW",
	KYRGYZSTAN: "KG",
	LAO_PEOPLE_S_DEMOCRATIC_REPUBLIC: "LA",
	LATVIA: "LV",
	LEBANON: "LB",
	LESOTHO: "LS",
	LIBERIA: "LR",
	LIBYA: "LY",
	LIECHTENSTEIN: "LI",
	LITHUANIA: "LT",
	LUXEMBOURG: "LU",
	MACAO: "MO",
	MADAGASCAR: "MG",
	MALAWI: "MW",
	MALAYSIA: "MY",
	MALDIVES: "MV",
	MALI: "ML",
	MALTA: "MT",
	MARSHALL_ISLANDS: "MH",
	MARTINIQUE: "MQ",
	MAURITANIA: "MR",
	MAURITIUS: "MU",
	MAYOTTE: "YT",
	MEXICO: "MX",
	MICRONESIA_FEDERATED_STATES_OF: "FM",
	MOLDOVA_REPUBLIC_OF: "MD",
	MONACO: "MC",
	MONGOLIA: "MN",
	MONTENEGRO: "ME",
	MONTSERRAT: "MS",
	MOROCCO: "MA",
	MOZAMBIQUE: "MZ",
	MYANMAR: "MM",
	NAMIBIA: "NA",
	NAURU: "NR",
	NEPAL: "NP",
	NETHERLANDS: "NL",
	NEW_CALEDONIA: "NC",
	NEW_ZEALAND: "NZ",
	NICARAGUA: "NI",
	NIGER: "NE",
	NIGERIA: "NG",
	NIUE: "NU",
	NORFOLK_ISLAND: "NF",
	NORTH_MACEDONIA: "MK",
	NORTHERN_MARIANA_ISLANDS: "MP",
	NORWAY: "NO",
	OMAN: "OM",
	PAKISTAN: "PK",
	PALAU: "PW",
	PALESTINE_STATE_OF: "PS",
	PANAMA: "PA",
	PAPUA_NEW_GUINEA: "PG",
	PARAGUAY: "PY",
	PERU: "PE",
	PHILIPPINES: "PH",
	PITCAIRN: "PN",
	POLAND: "PL",
	PORTUGAL: "PT",
	PUERTO_RICO: "PR",
	QATAR: "QA",
	ROMANIA: "RO",
	RUSSIAN_FEDERATION: "RU",
	RWANDA: "RW",
	REUNION: "RE",
	SAINT_BARTHELEMY: "BL",
	SAINT_HELENA_ASCENSION_AND_TRISTAN_DA_CUNHA: "SH",
	SAINT_KITTS_AND_NEVIS: "KN",
	SAINT_LUCIA: "LC",
	SAINT_MARTIN_FRENCH_PART: "MF",
	SAINT_PIERRE_AND_MIQUELON: "PM",
	SAINT_VINCENT_AND_THE_GRENADINES: "VC",
	SAMOA: "WS",
	SAN_MARINO: "SM",
	SAO_TOME_AND_PRINCIPE: "ST",
	SAUDI_ARABIA: "SA",
	SENEGAL: "SN",
	SERBIA: "RS",
	SEYCHELLES: "SC",
	SIERRA_LEONE: "SL",
	SINGAPORE: "SG",
	SINT_MAARTEN_DUTCH_PART: "SX",
	SLOVAKIA: "SK",
	SLOVENIA: "SI",
	SOLOMON_ISLANDS: "SB",
	SOMALIA: "SO",
	SOUTH_AFRICA: "ZA",
	SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: "GS",
	SOUTH_SUDAN: "SS",
	SPAIN: "ES",
	SRI_LANKA: "LK",
	SUDAN: "SD",
	SURINAME: "SR",
	SVALBARD_AND_JAN_MAYEN: "SJ",
	SWEDEN: "SE",
	SWITZERLAND: "CH",
	SYRIAN_ARAB_REPUBLIC: "SY",
	TAIWAN_PROVINCE_OF_CHINA: "TW",
	TAJIKISTAN: "TJ",
	TANZANIA_UNITED_REPUBLIC_OF: "TZ",
	THAILAND: "TH",
	TIMOR_LESTE: "TL",
	TOGO: "TG",
	TOKELAU: "TK",
	TONGA: "TO",
	TRINIDAD_AND_TOBAGO: "TT",
	TUNISIA: "TN",
	TURKMENISTAN: "TM",
	TURKS_AND_CAICOS_ISLANDS: "TC",
	TUVALU: "TV",
	TURKIYE: "TR",
	UGANDA: "UG",
	UKRAINE: "UA",
	UNITED_ARAB_EMIRATES: "AE",
	UNITED_KINGDOM: "GB",
	UNITED_STATES: "US",
	UNITED_STATES_MINOR_OUTLYING_ISLANDS: "UM",
	URUGUAY: "UY",
	UZBEKISTAN: "UZ",
	VANUATU: "VU",
	VENEZUELA_BOLIVARIAN_REPUBLIC_OF: "VE",
	VIET_NAM: "VN",
	VIRGIN_ISLANDS_BRITISH: "VG",
	VIRGIN_ISLANDS_U_S: "VI",
	WALLIS_AND_FUTUNA: "WF",
	WESTERN_SAHARA: "EH",
	YEMEN: "YE",
	ZAMBIA: "ZM",
	ZIMBABWE: "ZW",
	ALAND_ISLANDS: "AX",
};

export const COUNTRY_OPTIONS: CountryOption[] = (Object.keys(COUNTRY_ISO_CODES) as Country[]).map((countryCode) => ({
	code: countryCode,
	isoCode: COUNTRY_ISO_CODES[countryCode] ?? "",
	labelKey: `country_${countryCode.toLowerCase()}` as CountryTranslationKey,
}));

export const COUNTRY_OPTIONS_BY_CODE = COUNTRY_OPTIONS.reduce<Record<string, CountryOption>>((result, option) => {
	result[option.code] = option;
	return result;
}, {});

export const getCountryOptionLabel = (labelKey: CountryTranslationKey): string =>
	i18n.t(labelKey, { defaultValue: labelKey });

export const getCountryLabel = (countryCode: string | null | undefined): string => {
	if (countryCode == null || countryCode.length === 0) return "";
	const option = COUNTRY_OPTIONS_BY_CODE[countryCode];
	return option == null ? countryCode : getCountryOptionLabel(option.labelKey);
};

export const getCountryLabels = (): Record<Country, string> => {
	return Object.fromEntries(
		COUNTRY_OPTIONS.map((country) => [country.code, getCountryOptionLabel(country.labelKey)]),
	) as Record<Country, string>;
};

export const getCountryFlag = (countryCode: string | null | undefined): string => {
	if (countryCode == null || countryCode.length === 0) return "";
	const isoCode = COUNTRY_OPTIONS_BY_CODE[countryCode]?.isoCode;
	return isoCode == null ? "" : isoCodeToFlag(isoCode);
};

const isoCodeToFlag = (isoCode: string): string => {
	return isoCode
		.toUpperCase()
		.split("")
		.map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
		.join("");
};
